/**
 * Copyright Mántum All Rights Reserved.
 */
import Content from './content';
import store from './store';
import useEscape from '../../../hooks/useEscape';
import useSWR from 'swr';
import { KEY_ITEM, KEY_GROUP } from './constant';
import { validator } from '@mantum/kanela';

import type { DataSource } from '@mantum/kanela';
import type { Menu, Advanced, Namespace, Contexts, Groups } from './type';

type PropTypes = {
    advanced?: Advanced;
    dataSource: DataSource | Menu;
    message?: string;
    onClick?: (value: unknown) => void;
    onClose?: () => void;
    placeholder?: string;
    spaces?: number;
};

export default function Menu(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {},
    } = props

    // prettier-ignore
    const {
        namespace = {},
        revalidate = false
    } = advanced

    // prettier-ignore
    const {
        items = KEY_ITEM,
        groups = KEY_GROUP
    } = namespace as Namespace

    useEscape(() => {
        if (props.onClose) {
            props.onClose();
        }
    });

    const dataSource = validator.isDataSource(props.dataSource)
        ? (props.dataSource as DataSource)
        : null;

    const menu = !dataSource ? (props.dataSource as Menu) : null;

    const fetcher = () => store(props.dataSource);

    // prettier-ignore
    const { data } = useSWR(() => {
        return dataSource ? dataSource.url : null;
    }, fetcher, { revalidateOnFocus: revalidate });

    const contextValues = dataSource
        ? (data?.[items] as Contexts)
        : menu?.[items as keyof unknown];

    const groupsValues = dataSource
        ? (data?.[groups] as Groups)
        : menu?.[groups as keyof unknown];

    return (
        <Content
            advanced={advanced}
            contexts={contextValues}
            groups={groupsValues}
            message={props.message}
            onClick={props.onClick}
            onClose={props.onClose}
            placeholder={props.placeholder}
            spaces={props.spaces}
        />
    );
}
